import CreateWindow from "../puzzleWindow";
import consoleOpen from "./console-open.jpg";
import consoleClosed from "./console-closed.jpg";
import wireImages from "./*.png";
import "./index.css";
import throttle from "~src/helpers/throttle.js";

import { exitButtonPosition } from "../../helpers/exitButtonPosition"
import { html, render } from "lit-html";
import imagesLoaded from "imagesloaded";
import { userChoiceTracker } from "~src/helpers/userChoiceTracker";
import { tips } from "~/src/tips";
import { computerScreens } from "~src/helpers/computerScreens.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { registerEvent } from "../../helpers/analyticsMethods";

let downEvent = mobileOrNot() ? "touchstart" : "mousedown";
let upEvent = mobileOrNot() ? "touchend" : "mouseup";
let moveEvent = mobileOrNot() ? "touchmove" : "mousemove";

downEvent = "click";

// Punainen 2, sininen 5, valkoinen 3

let puzzleSolved = false;

let controlPanelExits = 0;

const UpperTouchGrid = ({ debug }) => html`
  <div class="upper-touch-grid ${debug ? "debug" : ""}">
    <div class="tg-row tg-row-first ${debug ? "debug" : ""}">
      <div class="socket ${debug ? "debug" : ""}" data-id="1"></div>
      <div class="socket ${debug ? "debug" : ""}" data-id="2"></div>
      <div class="socket ${debug ? "debug" : ""}" data-id="3"></div>
    </div>
    <div class="tg-row tg-row-second">
      <div class="socket ${debug ? "debug" : ""}" data-id="4"></div>
      <div class="socket ${debug ? "debug" : ""}" data-id="5"></div>
    </div>
  </div>
`;

const LowerTouchGrid = ({ debug }) => html`
  <div class="lower-touch-grid ${debug ? "debug" : ""}">
    <div class="tg-row tg-row-first ${debug ? "debug" : ""}">
      <div
        class="wire-not-connected ${debug ? "debug" : ""}"
        data-id="white"
      ></div>
      <div
        class="wire-not-connected ${debug ? "debug" : ""}"
        data-id="blue"
      ></div>
      <div
        class="wire-not-connected ${debug ? "debug" : ""}"
        data-id="red"
      ></div>
    </div>
  </div>
`;

const DisposeBlock = ({ debug }) => html`
  <div class="dispose-block ${debug ? "debug" : ""}"></div>
`;

let currentGridColumn = 0;
let activeWire = null;

let reservedSockets = [];
let currentConnections = {
  // [file, socket]
  red: ["Puna", 0],
  white: ["Valko", 0],
  blue: ["Sini", 0],
};

const wirePicker = ({ wires, active, selected, color }) => {
  const isReserved = () => {
    let arr = Object.keys(currentConnections);
    for (let i = 0; i < arr.length; i++) {
      const value = currentConnections[arr[i]][1];
      if (value === currentGridColumn) return true;
    }
    return false;
  };

  let file


  if (!active) {
  // johto ei ole aktiivinen:
  // 1. Jos kytketty, laita vanhaan paikkaan
  // 2. Jos ei ole kytketty, älä laita mihinkään

    if (currentConnections[color]) {
      file = currentConnections[color][0];
    } else {
      file = wires[0];
      currentConnections[color] = [file, currentGridColumn];
    }
  }



  if (active) {
      // johto on aktiivinen
  // 1. jos socket varattu, älä tee mitään
  // 2. Jos socket ei ole varattu, kytke siihen,ja tee uusi varaus
    if (isReserved()) {
      file = currentConnections[color][0];
    } else if (!isReserved()) {
      if (!window.scene.getSoundByName("electricWire")?.isPlaying) {
        window.scene.getSoundByName("electricWire")?.play();
      }
      file = wires[parseInt(currentGridColumn, 10)];
      currentConnections[color] = [file, currentGridColumn];
    } else {
      console.log("unknown option");
    }
  }

  return html`<img
    class="wire"
    style="filter: ${active ? "drop-shadow(4px -5px 0px green)" : "unset"};"
    draggable="false"
    src=${wireImages[file]}
  />`;
};

let wireFileNames = {
  red: ["Puna", "Puna_1", "Puna_2", "Puna_3", "Puna_4", "Puna_5"],
  white: ["Valko", "Valko_1", "Valko_2", "Valko_3", "Valko_4", "Valko_5"],
  blue: ["Sini", "Sini_1", "Sini_2", "Sini_3", "Sini_4", "Sini_5"],
};

let allImagesLoaded = false;

const FlatPuzzle = function (scene, sounds) {
  console.log(scene);
  const { red, white, blue } = wireFileNames;
  const markup = () => html`
    <div class="container electricPanel">
      <div class="console">
        <img
          class="console-bg"
          src=${userChoiceTracker.retrieve().electricPanel
            ? consoleOpen
            : consoleClosed}
          draggable="false"
        />
        ${wirePicker({
          wires: red,
          active: activeWire === "red",
          selected: null,
          color: "red",
        })}
        ${wirePicker({
          wires: blue,
          active: activeWire === "blue",
          selected: null,
          color: "blue",
        })}
        ${wirePicker({
          wires: white,
          active: activeWire === "white",
          selected: null,
          color: "white",
        })}
        ${UpperTouchGrid({ debug: false })} ${LowerTouchGrid({ debug: false })}
        ${DisposeBlock({ debug: false })}
        ${!allImagesLoaded
          ? html` <div id="fake-images" style="display: none">
                <img src=${consoleOpen} style="width: 0; height: 0" />
                <img src=${consoleClosed} style="width: 0; height: 0" />
                ${Object.values(wireImages).map(
                  (e) => html`<img src=${e} style="width: 0; height: 0" />`
                )}
              </div>
              <div id="loading">LADATAAN</div>
              -`
          : html``}
      </div>
    </div>
  `;
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const { element, exit } = CreateWindow({
    exitCallback: () => {
      document.documentElement.style.overflow = "auto";
      document.querySelector("#modal-content").style.overflow = "auto";
      controlPanelExits++;
      if (!puzzleSolved && controlPanelExits === 2) {
        tips.solveControlPanel1.setTime(1, {override: true});
      } else if (!puzzleSolved && controlPanelExits === 3) {
        tips.solveControlPanel2.setTime(1);
      } else if (puzzleSolved) {
        tips.solveControlPanel1.clear();
        tips.solveControlPanel2.clear();
        tips.bunkerComputer.setTime(30);
      }
    },
  });
  const puzzleWindow = element;
  render(markup(), puzzleWindow);
  imagesLoaded(".electricPanel", function () {
    allImagesLoaded = true;
    render(markup(), puzzleWindow);
  });

  (function hideScrollBars() {
    document.querySelector(".electricPanel").parentElement.style.overflow =
      "hidden";
    document.documentElement.style.overflow = "hidden";
  })();

  const electricPanel = document.querySelector(".console");

  let isMouseDown = false;
  function clickHandler(event) {
    const targetElement = event.target;
    console.log(targetElement)
    const classList = targetElement.classList;
    if (classList.contains("wire-not-connected")) {
      // wire click
      activeWire = event.target.dataset.id;
      console.log("active wire is " + activeWire);
    }

    if (classList.contains("socket")) {
      // socket click

      currentGridColumn = targetElement.dataset.id;
      
      const socketNr = targetElement.dataset.id;
      // checks if there is a wire, if true activate that wire
      let arr = Object.keys(currentConnections);
      for (let i = 0; i < arr.length; i++) {
        const value = currentConnections[arr[i]][1];
        if (value === socketNr) {
          activeWire = arr[i];
        }
      } 
      
      currentConnections[activeWire][0] = wireFileNames[activeWire][parseInt(currentGridColumn, 10)]
      currentConnections[activeWire][1] = currentGridColumn
    }

    if (targetElement.classList.contains("dispose-block")
    ) {
      // dispose block
      let file = wireFileNames[activeWire][0];
      currentConnections[activeWire][0] = file;
      currentConnections[activeWire][1] = "0";
      currentGridColumn = 0;
    }

    if (isMouseDown && targetElement.classList.contains("socket")) {
      // Pointer is abovesocket
  //    render(markup(), puzzleWindow);
    }


    if (
      currentConnections["red"][1] === "4" &&
      currentConnections["blue"][1] === "5" &&
      currentConnections["white"][1] === "3"
    ) {
      if (sounds) sounds();
    
      registerEvent("Sahkokaappi_ratkaistu") 

      userChoiceTracker.electricPanelPuzzleResolved(true);
      puzzleSolved = true;
      computerScreens.bunker.open();
      render(markup(), puzzleWindow);
      window.setTimeout(() => {
        exit();
        document.querySelector("#modal-content").style.overflow = "auto";
      }, 1000); }
          render(markup(), puzzleWindow);
  }

  electricPanel.addEventListener("click", clickHandler, true);


  exitButtonPosition();
  
};

export default FlatPuzzle;
